import { baseMockEnvironment, TEnvironmentSettings } from '@pb/services';

const appSpecificMockEnvironment = {};

export const mockEnvironment: TEnvironmentSettings = {
    ...baseMockEnvironment,
    ...appSpecificMockEnvironment,
};
